/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './shift.reducer';

export const ShiftDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const shiftEntity = useAppSelector(state => state.shift.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="shiftDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.shift.detail.title">Shift</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.shift.id">Id</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.shift.name">Name</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.name}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.shift.code">Code</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.code}</dd>
          <dt>
            <span id="from">
              <Translate contentKey="tinyMedicRestApp.shift.from">From</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.from}</dd>
          <dt>
            <span id="to">
              <Translate contentKey="tinyMedicRestApp.shift.to">To</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.to}</dd>
          <dt>
            <span id="length">
              <Translate contentKey="tinyMedicRestApp.shift.length">Length</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.length}</dd>
          <dt>
            <span id="hasBonus">
              <Translate contentKey="tinyMedicRestApp.shift.hasBonus">Has Bonus</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.hasBonus ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.shift.active">Active</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.shift.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.shift.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.shift.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.shift.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{shiftEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.shift.hospital">Hospital</Translate>
          </dt>
          <dd>{shiftEntity.hospital ? shiftEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/shift" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/shift/${shiftEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ShiftDetail;
